module.exports = __webpack_public_path__ + "img/logo-vtm-footer-white.ce0f48c9.png";